import { ChunkStage, World, WorldName } from './world';
import { ParallaxType } from '../../core/modules/Parallax/ParallaxController';
import ChunkStart from '../chunks/shipwreck/ChunkStart';
import TestChunkSmashables from '../chunks/test/TestChunkSmashables';
import TestChunkTraps from '../chunks/test/TestChunkTraps';
import TestChunkPlatformCollision from './../chunks/test/TestChunkPlatformCollision';

export const testWorld: World = {
  id: WorldName.Test,
  texture: 'game-all',
  parallaxLayers: [
    {
      type: ParallaxType.Tile,
      texture: 'game-all',
      frame: 'bg-sky.png',
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    {
      type: ParallaxType.Tile,
      x: 960,
      y: 300,
      width: 1920,
      height: 87,
      texture: 'game-all',
      frame: 'tile-sea.png',
      depth: 1,
      scrollX: 0,
      scrollY: 1,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    }
  ],
  playerSpawnPoint: { x: 100, y: -20 },
  hasHardFloor: true,
  deathFloorY: 300,
  chunkStartX: 0,
  chunkStartY: 300,
  relics: [],
  chunks: {
    [ChunkStage.Start]: [ChunkStart],
    [ChunkStage.Mid]: [TestChunkPlatformCollision]
  },
  stageOrdering: [
    {
      name: ChunkStage.Start,
      distance: 0
    },
    {
      name: ChunkStage.Mid
    }
  ]
};
